<template>
  <v-app>
    <div class="full-height full-width">
      <v-fade-transition>
        <router-view/>
      </v-fade-transition>
    </div>
    <v-snackbar
      top
      right
      v-model="snackbar.show"
      close-delay="2000"
      color="transparent"
      elevation="0"
      content-class="toast-content"
    >
      <div class="toast-card" :class="`toast-card-${toastType.key}`">
        <span class="toast-icon-chip">
          <v-icon :color="toastType.color" size="20">{{ toastType.icon }}</v-icon>
        </span>
        <span class="toast-text">{{ snackbar.text }}</span>
        <button type="button" class="toast-dismiss-btn" @click="snackbar.show = false">
          <v-icon size="16">mdi-close</v-icon>
        </button>
      </div>
    </v-snackbar>
    <v-overlay :value="overlay.loading">
      <v-progress-circular indeterminate color="primary"/>
    </v-overlay>
    <Cookies />
    <v-dialog v-model="securitySuspendedDialog" max-width="420">
      <v-card class="pa-2">
        <v-card-title>{{ $t('accountSuspendedTitle') }}</v-card-title>
        <v-card-text>
          <p>{{ $t('accountSuspendedDesc') }}</p>
          <p>{{ $t('accountSuspendedContact') }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text color="primary" class="text-none" @click="securitySuspendedDialog = false">{{ $t('accountSuspendedClose') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>

import http from './service/axios';
import Cookies from './components/pages/fragments/Cookies.vue';

export default {
  name: 'App',
  components: {
    Cookies
  },

  data: () => ({
    snackbar: {show: false, color: 'error', text: ''},
    overlay: {loading: false},
    securitySuspendedDialog: false,
    toastTypes: {
      success: {key: 'success', icon: 'mdi-check-circle', color: '#00A876'},
      error: {key: 'error', icon: 'mdi-alert-circle', color: '#D64545'},
      warning: {key: 'warning', icon: 'mdi-alert', color: '#B45309'},
      info: {key: 'info', icon: 'mdi-information', color: '#0277BD'},
    },
  }),

  computed: {
    toastType: function() {
      return this.toastTypes[this.snackbar.color] || this.toastTypes.info
    }
  },

  watch: {
  },
  mounted: function() {
   
    // if (location.host != '' && location.protocol !== 'https:' && process.env.VUE_APP_ENVIROMENT == 'PRD') {
    //   location.replace(`https:${location.href.substring(location.protocol.length)}`);
    // }
    this.$commons.updateSnackbar = (snackbar) => {
      this.snackbar = snackbar
    }
    this.$commons.updateOverlayLoading = (loading) => {
      this.overlay.loading = loading
    }
    http.interceptors.response.use(
      response => response,
      error => {
        // account-security-suspension: shown on any authenticated screen, from any
        // request that comes back with this marker - not only a login attempt - so
        // it survives logout/login the way the underlying server-side block does.
        if(error.response && error.response.status === 403 && error.response.data && error.response.data.error === 'account.security.suspended') {
          this.securitySuspendedDialog = true
        } else if(error.response.data && error.response.data.messages)
          error.response.data.messages.forEach((element,index) => {
            setTimeout(() => {
              // A backend error code with no matching i18n key (in any locale) would
              // otherwise render as that raw code (e.g. "required.action") via
              // vue-i18n's own fallback - $te() lets us show a translated generic
              // message instead for exactly that case.
              const text = this.$te(element.message) ? this.$t(element.message) : this.$t('genericError')
              this.$commons.updateSnackbar({show: true, color: 'error', text})
            }, index * 1000);
          });
        // if (error.response.status === 403) {
        //   localStorage.clear()
        // }
        return Promise.reject(error);
      }
    )
  },
  methods: {

  }

};
</script>

<style lang="scss">
// Montserrat é carregada globalmente em public/index.html (única fonte do
// site público). As outras famílias usadas pelas classes .roboto/.lora/etc.
// abaixo (seletor de fonte da página de bio) são carregadas sob demanda por
// src/service/bio-fonts.js, direto onde a bio é renderizada — não aqui,
// para não pesar o carregamento de fonte de toda página do site.
$font-family:'Montserrat';

.v-application {
  [class*='text-'] {
    color: #36405a;
    font-family: $font-family, sans-serif;
  }
  font-family: $font-family, sans-serif;
  height: 100%;
  max-height: 100%;
}
* {
  // font-family: $font-family, sans-serif;
  word-break: normal !important;
}
.display-title-1 {
    font-size: 3.9rem !important;
    font-family: $font-family, sans-serif !important;
    font-style: normal !important;
    font-weight: 900 !important;
    line-height: normal !important;
}

.display-title-2 {
  text-align: center !important;
  /* H2 - md */
  font-size: 2.7rem!important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: normal !important;
}

.v-application .display-title-3 {
    font-size: 3.75rem !important;
    font-weight: 300;
    line-height: 3.75rem;
    letter-spacing: -0.0083333333em !important;
}

html {
  scroll-behavior: smooth;
}
.full-height {
  height: 100vh;
  max-height: 100vh;
  scroll-behavior: smooth;
  overflow-y: auto;
  overflow-x: clip;
}
.full-height-painel {
  height: calc(100vh - var(--painel-app-bar-height, 0px));
  max-height: calc(100vh - var(--painel-app-bar-height, 0px));
  scroll-behavior: smooth;
  overflow-y: auto;
  overflow-x: clip;
}
.full-height-90 {
  height: 93vh;
  max-height: 100%;
  scroll-behavior: smooth;
  overflow-y: auto;
  overflow-x: clip;
}
.full-height-80 {
  height: 83vh;
  max-height: 100%;
  scroll-behavior: smooth;
  overflow-y: auto;
  overflow-x: clip;
}
.full-width {
  width: 100vw; 
  max-width: 100vw;
}
.m-0 {
  margin: 0px;
}
.p-0 {
  padding: 0px;
}
::-webkit-scrollbar {
    width: 1px;
    height: 2em
}
::-webkit-scrollbar-button {
    background: transparent
}
::-webkit-scrollbar-track-piece {
    background: transparent
}
::-webkit-scrollbar-thumb {
  background: #eee
}
.card-circle {
  border-radius: 50% !important;
}

.bg-main {
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: cover !important;
}

.badge-info .v-badge__badge {
  height: none !important;
  padding: 0px !important;
  z-index: 9;
  white-space: normal !important;
}

.avatar-breed {
  border: 1px dotted white !important;
}

/* Moved here from PainelBioPage.vue's unscoped <style> block, where these
   rules originally lived by accident - IndexPage.vue and
   fragments/InfoproductEdit.vue also render plain
   `<div class="mobile-preview-container">` elements of their own (outside
   PainelBioPage's component tree) and were silently depending on that
   leak for their own phone-mockup styling. Scoping PainelBioPage's style
   block (a real bug - it also leaked a global `input:focus{outline:none}`
   onto every input in the app) would have broken both of those pages, so
   these specific rules belong here instead, genuinely shared. */
.mobile-preview-frame {
  position: relative;
  margin: auto;
  width: 300px;
  height: 600px;
  padding: 10px;
}
.mobile-preview-frame-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
}
/* height (not just max-height) so BiographySmartphoneView's forceMobile
   height:100% has a definite percentage base to resolve against - see
   that component's .bio-shell-scroll comment for why the actual
   scrolling now happens inside .bio-shell itself, not here. */
.mobile-preview-dialog-card {
  height: 500px;
}
.mobile-preview-container {
  position: relative;
  z-index: 1;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  border-radius: 40px 40px 35px 35px;
}
.mobile-preview-container::-webkit-scrollbar {
  width: 0px;
}

/* Shared tactile-press feedback for the painel (admin) screens - mirrors
   .bio-tactile already established on the public bio page. Most painel
   buttons/cards already have a :hover lift but nothing on :active, so a
   click/tap doesn't visibly "respond". Global (not per-component scoped)
   since it's meant to be reused across every painel-*.vue and fragment
   without redeclaring the same 8 lines in each file. */
.dash-tactile {
  transition: transform 0.15s ease;
}
.dash-tactile:active {
  transform: scale(0.96);
}
@media (prefers-reduced-motion: reduce) {
  .dash-tactile {
    transition: none;
  }
  .dash-tactile:active {
    transform: none;
  }
}

.avatar-craft {
  border: 1px dotted grey !important;
}

.verticle-center {
  min-height: 100%;
  display: flex;
  align-items: center;
}
.horizontaly-center {
  margin: auto;
}

.link{
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
}

.bg-card{
  background: rgb(255, 255, 255, 0.1);
  backdrop-filter: blur( 10px );
  -webkit-backdrop-filter: blur(10px);
}

.pointer {
  cursor: pointer;
}

.text-line-through{
  text-decoration: line-through;
}

.rounded-card{
    border-radius:50% !important;
}

// .v-navigation-drawer--fixed{
//   z-index: 9 !important;
// }

// .v-navigation-drawer--fixed{
//   z-index: 6 !important;
// }

.v-toolbar.v-toolbar--absolute{
  z-index: auto !important;
}

.lowercase input{
  text-transform: lowercase
}


.free-plan-obfuscate {
  background: rgb(255, 255, 255, 0.1) !important;
  -webkit-backdrop-filter: blur(5px) !important;
  -webkit-filter: blur(5px) !important;
}

.card-corner-radius{
  border-radius: 15px !important;
}

.append-outer-no-margin-top .v-input__append-outer {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.subtitle-deafault{
  color: #7E8EA6;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.all-text {
  white-space: pre-line !important
}
.description--text{
  color: #7E8EA6 !important;
}

.text-end-input input {
  text-align: end !important
}
.avatar-instagram{
  border: solid 1px #7E8EA6;
}
.avatar-instagram-username {
  transform: rotate(355deg);
}

.roboto {
  font-family: "Roboto", sans-serif !important;
  font-weight: 400;
}

.montserrat {
  font-family: "Montserrat", sans-serif !important;
  font-weight: 400;
}

.lora {
  font-family: "Lora", serif !important;
  font-weight: 400;
}

.raleway {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
}

.open-sans {
  font-family: "Open Sans", sans-serif !important;
  font-weight: 400;
}

.merriweather {
  font-family: "Merriweather", serif !important;
  font-weight: 400;
}

.noto-serif-oriya {
  font-family: "Noto Serif Oriya", serif !important;
  font-weight: 400;
}

.architects-daughter {
  font-family: "Architects Daughter", cursive !important;
  font-weight: 400;
  font-style: normal;
}

.permanent-marker-regular {
  font-family: "Permanent Marker", cursive !important;
  font-weight: 400;
  font-style: normal;
}


@media (min-width: 960px) {
  .container {
    max-width: 900px;
  }
}
@media (min-width: 1264px) {
  .container {
    max-width: 1140px !important;
  }
}
@media (min-width: 1904px) {
  .container {
    max-width: 1140px !important;
  }
}

.underline-hover::after {
  content: '';
  width: 0;
  height: 1.5px;
  display: block;
  left: 0;
  background: #3498db;
  transition: width 0.3s ease;
  -webkit-transition: width 0.3s ease;
}

.underline-hover:hover {
  // color: #3498db;
}

.underline-hover:hover::after {
  width: 100%;
}

/* Toast notification */
.toast-content {
  padding: 0 !important;
}
.toast-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #FFFFFF;
  border-radius: 1.25rem;
  box-shadow: 0 14px 30px rgba(16,24,39,0.14);
  padding: 0.75rem 0.9rem;
  font-family: $font-family, sans-serif;
}
.toast-icon-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.toast-card-success .toast-icon-chip {
  background: rgba(0,168,118,0.12);
}
.toast-card-error .toast-icon-chip {
  background: rgba(214,69,69,0.12);
}
.toast-card-warning .toast-icon-chip {
  background: rgba(180,83,9,0.12);
}
.toast-card-info .toast-icon-chip {
  background: rgba(2, 119, 189, 0.12);
}
.toast-text {
  flex: 1;
  min-width: 0;
  color: #101827;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.4;
}
.toast-dismiss-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #5B6472;
  cursor: pointer;
  transition: background 0.2s ease;
}
.toast-dismiss-btn:hover {
  background: rgba(16,24,39,0.06);
}
</style>